import React, { Component, Fragment } from "react";
import styled, { ThemeProvider, keyframes } from "styled-components";
import { Grid, Col, Row } from "react-styled-flexboxgrid";
import DocumentMeta from "react-document-meta";
import he from "he";

import * as actions from "../../actions";
import { connect } from "react-redux";

import ContentHeader from "../layout/ContentHeader";
import PanelWrapper from "../layout/PanelWrapper";
import Loader from "../Loader";

const theme = {
  flexboxgrid: {
    // Defaults
    gridSize: 12, // rem
    gutterWidth: 0, // rem
    outerMargin: 0, // rem
    mediaQuery: "only screen",
    container: {
      sm: 30, // rem
      md: 50, // rem
      lg: 61.25 // rem
    },
    breakpoints: {
      xs: 0, // em
      sm: 30, // em
      md: 50, // em
      lg: 61.25 // em
    }
  }
};

class ContactContent extends Component {
  componentDidMount(prevProps) {
    window.scrollTo(0, 0);
    this.props.loadContactContent();
  }

  render() {
    const meta = {
      title: "Contact - Arthur Perfect Job",
      description:
        "Contact Arthur Perfect Job for all of your home renovation needs. Plumbing, Demolition, Carpentry / Joinery, Electrics, Plastering / Rendering, Flooring, Drylining, Painting and Decorating, Suspended Ceilings, Handyman Service, Partition walls, Tiling.",
      meta: {
        charset: "utf-8",
        name: {
          keywords:
            "plumbing,demolition,carpentry,joinery,electrics,plastering,rendering,flooring,drylining,painting,decorating,suspended,ceilings,handyman,service,partition,walls,tiling.",
          "og:title": "Contact - Arthur Perfect Job",
          "og:img": "https://apjhomerenovation.co.uk/img/opengraph.jpg",
          "og:type": "website"
        }
      }
    };

    return (
      <Fragment>
        <DocumentMeta {...meta} />
        <ContentHeader
          title="CONTACT"
          description="Please use the contact form below to contact us and we'll get in touch shortly"
        />

        <ThemeProvider theme={theme}>
          <Grid style={{ width: "100%" }}>
            {/* <Row style={{ padding: 0, margin: 0 }}> */}
            <Row>
              <Col xs={12} sm={12} md={8} lg={8}>
                <FormContainer>
                  <form
                    method="POST"
                    action="https://formspree.io/artursmakarovs@yahoo.co.uk"
                  >
                    <PanelWrapper>
                      <Field>
                        <Label>Name</Label>
                        <TextInput name="Name" />
                      </Field>
                      <Field>
                        <Label>E-mail</Label>
                        <TextInput name="E-mail" />
                      </Field>
                      <Field>
                        <Label>Message</Label>
                        <TextArea name="Message" />
                      </Field>
                      <ButtonContainer>
                        <Button>Send</Button>
                      </ButtonContainer>
                    </PanelWrapper>
                  </form>
                </FormContainer>
              </Col>
              <Col xs={12} sm={12} md={4} lg={4}>
                <ContactDetailsContainer>
                  <PanelWrapper>
                    {this.props.content.loading ? (
                      <Loader />
                    ) : (
                      <Text>{he.decode(this.props.content.panelText)}</Text>
                    )}
                  </PanelWrapper>
                </ContactDetailsContainer>
              </Col>
            </Row>
          </Grid>
        </ThemeProvider>
      </Fragment>
    );
  }
}

const FormContainer = styled.div`
  padding: 0;
  margin: 0 10px 0 0;
  @media only screen and (max-width: 980px) {
    width: 100%;
    padding: 0;
    margin: 0;
  }
`;

const Field = styled.div`
  width: 100%;
  margin-bottom: 10px;
  position: relative;
`;

const Label = styled.label`
  color: #ffc300;
  text-transform: uppercase;
  display: block;
  padding-bottom: 5px;
  @media only screen and (max-width: 980px) {
    margin: 0;
  }
`;

const TextInput = styled.input`
  display: block;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border: none;
  font-size: 15px;
  width: 100%;
  padding: 0;
  margin: 0;
  padding: 10px;
  margin: 2px 0;
  box-sizing: border-box;
`;

const TextArea = styled.textarea`
  display: block;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.2);
  border: none;
  font-size: 15px;
  width: 100%;
  padding: 10px;
  height: 150px;
  margin: 2px 0;
  box-sizing: border-box;
`;

const ButtonContainer = styled.div`
  width: 100%;
  position: relative;
  display: block;
  text-align: right;
`;

const Button = styled.button`
  margin: 0;
  padding: 4px 55px;
  color: #000000;
  background: rgba(253, 186, 3, 1);
  font-family: "Bree Serif", serif;
  text-transform: uppercase;
  font-size: 13px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  border: none;
  width: 100%;
  padding: 0;
  margin: 0;
  padding: 10px;
  height: 30;
  margin: 2px 0;
  box-sizing: border-box;
`;

const ContactDetailsContainer = styled.div`
  padding: 0;
  margin: 0;
  @media only screen and (max-width: 980px) {
    flex: none;
    width: 100%;
    display: block;
    margin: 0;
    padding: 0;
  }
`;

const fadeIn = keyframes`
  from {
    opacity: 0;
  }

  to {
    opacity: 1;
  }
`;

const Text = styled.p`
  font-weight: 300;
  font-family: "Open Sans", sans-serif;
  color: #ffffff;
  padding: 0;
  margin: 0;
  font-size: 14px;
  animation: ${props => (props.out ? fadeIn : fadeIn)} 0.4s linear;
  transition: visibility 1s linear;
`;

function mapStateToProps(state) {
  return { content: state.contact };
}

export default connect(mapStateToProps, actions)(ContactContent);



// WEBPACK FOOTER //
// ./src/components/pages/ContactContent.js